<ng-container *ngIf="user">
    <div id="master-profile-nav">
        <div class="master-left">
            {{ user.first_name + ' ' + user.last_name }}<br/>
            {{ user.email }}
        </div>
        <div class="master-right">
            <button
                    (click)="openUserMeals(user)"
                    type="button"
                    class="btn-meals btn btn-sm btn-primary btn-icon-text">
                <i class="ti-apple btn-icon-prepend"></i>
                {{ 'hraneniq' | localise }}
            </button>

            <button
                    (click)="router.navigate(['master/profiles/settings', user.id])"
                    type="button"
                    class="btn-settings btn btn-sm btn-secondary btn-icon-text">
                <i class="ti-settings btn-icon-prepend"></i>
                {{ 'just_settings' | localise }}
            </button>

            <i class="icon-options-vertical"
               style="font-size: 1.8rem; margin-left: 5px; color: #d89d03; cursor: pointer;"
               [app-popup]="{
                                  templateRef: actionMoreButtons,
                                  position: 'bottom',
                                  arrowPosition: ['top', 'right'],
                                  paddingless: true,
                                  closeUponSelection: true
                                }"></i>
            <ng-template #actionMoreButtons>
                <a class="dropdown-item preview-item" (click)="router.navigate(['master/profiles/subscriptions', user.id])">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="ti-lock text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'access' | localise }}</div>
                </a>

                <a class="dropdown-item preview-item" (click)="router.navigate(['master/profiles/notes', user.id])">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="ti-notepad text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'notes' | localise }}</div>
                </a>

                <a class="dropdown-item preview-item" (click)="openMessages(user)">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="fa fa-wechat text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'messages' | localise }}</div>
                </a>


                <a class="dropdown-item preview-item" (click)="router.navigate(['master/nutrients', profile.id])">
                    <div class="preview-thumbnail">
                        <div class="responsive-flex-wrapper">
                            <i class="fa fa-apple text-primary"></i>
                        </div>
                    </div>
                    <div class="preview-item-content">{{ 'nutrients' | localise }}</div>
                </a>
            </ng-template>
        </div>
        <div class="master-clear"></div>
    </div>
</ng-container>

<div class="row">
    <div id="chat" #chat>
        <div
                *ngFor="let chatMessage of chatMessages; let i = index"
                class="message"
                [ngClass]="chatMessage.sender.id === user.id ? 'second-user-message' : ''"
        >
            <div class="message-container2">
                <p class="author">
                    {{ chatMessage.sender.first_name }} {{ chatMessage.sender.last_name }}

                    <ng-container *ngIf="chatMessage.sender.id != user.id">
                        <span *ngIf="chatMessage.receiver_seen == false"><i title="Not Seen" class="not-seen fa fa-times-circle"></i></span>
                        <span *ngIf="chatMessage.receiver_seen == true"><i title="Seen" class="seen fa fa-check-circle"></i></span>
                    </ng-container>
                </p>
                <div class="message-text" [innerHTML]="chatMessage.message | keepHtml"></div>
                <p class="time">{{ formatCreatedTime(chatMessage.created_at) }}</p>
            </div>

            <div style="clear: both;"></div>
        </div>

    </div>

    <div id="chat-textarea">
        <textarea placeholder="{{ 'new_message' | localise }}" name="textarea" id="textarea-chat" [(ngModel)]="chatMessage"></textarea>
        <button id="send" class="btn btn-sm btn-primary" (click)="sendMessage()">{{ 'site_send' | localise }}</button>
    </div>
</div>
